export default __webpack_public_path__ + "static/media/blue_paper_rip.70149d58.jpg";